import { useEffect, useRef } from 'react';

/* ============================================================
   FC LOGO
   ============================================================ */
export function FCLogo({ size = 40, withText = false }) {
  return (
    <div className="row gap-3" style={{ alignItems: 'center' }}>
      <div style={{
        width: size, height: size, borderRadius: '50%', flexShrink: 0,
        backgroundImage: 'url(/assets/logo-federation.png)', backgroundSize: 'cover', backgroundPosition: 'center',
        border: '1.5px solid rgba(225,18,23,0.55)', boxShadow: 'inset 0 0 0 2px rgba(0,0,0,0.5)',
      }} />
      {withText && (
        <div className="col" style={{ lineHeight: 1 }}>
          <span className="display" style={{ fontSize: 17, letterSpacing: '0.02em' }}>FIFA OPEN</span>
          <span className="mono" style={{ fontSize: 9.5, letterSpacing: '0.22em', color: 'var(--fg-muted)', marginTop: 3 }}>СКО · PLAYSTATION</span>
        </div>
      )}
    </div>
  );
}

/* ============================================================
   FLAGS — картинки вместо эмодзи (Windows не рендерит эмодзи-флаги)
   ============================================================ */
export const FLAG_CODES = {
  'Хорватия': 'hr', 'Германия': 'de', 'Канада': 'ca', 'ЮАР': 'za', 'Австралия': 'au',
  'Франция': 'fr', 'Чехия': 'cz', 'Уругвай': 'uy', 'Нидерланды': 'nl', 'Парагвай': 'py',
  'Норвегия': 'no', 'Кюрасао': 'cw', 'Бразилия': 'br', 'Япония': 'jp', 'Узбекистан': 'uz',
  'Египет': 'eg', 'Кабо-Верде': 'cv', 'Австрия': 'at', 'Тунис': 'tn', 'Бельгия': 'be',
  'Кот-д’Ивуар': 'ci', 'Босния и Герцеговина': 'ba', 'Босния': 'ba', 'Марокко': 'ma',
  'Португалия': 'pt', 'Швеция': 'se', 'Иордания': 'jo', 'Швейцария': 'ch', 'Испания': 'es',
  'Шотландия': 'gb-sct', 'Юж. Корея': 'kr', 'Колумбия': 'co', 'Иран': 'ir', 'Конго': 'cg',
  'Гана': 'gh', 'Аргентина': 'ar', 'Англия': 'gb-eng', 'Алжир': 'dz', 'Панама': 'pa',
  'Сенегал': 'sn', 'Гаити': 'ht',
};

export function Flag({ team, size = 20, style }) {
  const code = FLAG_CODES[team];
  if (!code) {
    return <BallIcon size={size * 0.8} color="var(--fg-faint)" style={style} />;
  }
  return (
    <img src={`/assets/flags/${code}.png`} alt={team} width={size} loading="lazy"
      style={{ borderRadius: 3, boxShadow: '0 1px 4px rgba(0,0,0,0.55), 0 0 0 0.5px rgba(255,255,255,0.15)', display: 'block', flexShrink: 0, ...style }} />
  );
}

/* ============================================================
   ICONS
   ============================================================ */
export function BallIcon({ size = 16, color = 'currentColor', style, className }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.6" style={style} className={className}>
      <circle cx="12" cy="12" r="9.2" />
      <path d="M12 7.6 L16.2 10.6 L14.6 15.4 L9.4 15.4 L7.8 10.6 Z" />
      <path d="M12 2.8 V7.6 M16.2 10.6 L20.8 9.2 M14.6 15.4 L17.6 19.4 M9.4 15.4 L6.4 19.4 M7.8 10.6 L3.2 9.2" />
    </svg>
  );
}
export function TrophyIcon({ size = 18, color = 'currentColor' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <path d="M8 21h8M12 17v4M7 4h10v5a5 5 0 0 1-10 0V4Z" />
      <path d="M7 6H4.5a1.5 1.5 0 0 0 0 3H7M17 6h2.5a1.5 1.5 0 0 1 0 3H17" />
    </svg>
  );
}
export function Ic({ d, size = 16, color = 'currentColor' }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d={d} /></svg>;
}
export const IC = {
  cal: 'M8 2v4M16 2v4M3 10h18M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z',
  pin: 'M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z M12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z',
  users: 'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2 M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z M22 21v-2a4 4 0 0 0-3-3.87 M16 3.13a4 4 0 0 1 0 7.75',
  send: 'M22 2 11 13 M22 2 15 22l-4-9-9-4 22-7Z',
  whistle: 'M9 9h6l6-2v4a8 8 0 1 1-12-2Z M9 13a2 2 0 1 0 0 .01',
  gamepad: 'M6 12h4M8 10v4M15 11h.01M18 13h.01M17.5 6H6.5a5.5 5.5 0 0 0-.5 11c1.5 0 2.5-.8 3.2-1.8h5.6c.7 1 1.7 1.8 3.2 1.8a5.5 5.5 0 0 0-.5-11Z',
  home: 'M3 10.5 12 3l9 7.5 M5 9.5V21h14V9.5 M9.5 21v-6h5v6',
  play: 'M8 5.5v13l11-6.5-11-6.5Z',
  grid: 'M3 3h7v7H3zM14 3h7v7h-7zM3 14h7v7H3zM14 14h7v7h-7z',
  tv: 'M4 7h16a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1Z M8 3l4 4 4-4',
  phone: 'M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92Z',
  bolt: 'M13 2 4 14h6l-1 8 9-12h-6l1-8Z',
  cup: 'M8 21h8M12 17v4M7 4h10v5a5 5 0 0 1-10 0V4Z M7 6H4.5a1.5 1.5 0 0 0 0 3H7M17 6h2.5a1.5 1.5 0 0 1 0 3H17',
};

/* ============================================================
   FOOTBALL BACKGROUND — glow + turf stripes + pitch geometry
   ============================================================ */
export function FootballBackground({ intensity = 1 }) {
  return (
    <div aria-hidden="true" style={fcBgStyles.wrap}>
      <div style={{ ...fcBgStyles.glowRed, opacity: 0.5 * intensity }} />
      <div style={{ ...fcBgStyles.glowPitch, opacity: `calc(var(--pitch-a) * ${0.65 * intensity})` }} />
      <div style={{ ...fcBgStyles.glowGold, opacity: 0.35 * intensity }} />
      {/* полосы стрижки газона */}
      <div style={{ ...fcBgStyles.turf, opacity: 'calc(var(--pitch-a) * 0.16)' }} />
      <div style={fcBgStyles.grid} />
      <svg viewBox="0 0 1200 600" preserveAspectRatio="xMidYMin slice" style={fcBgStyles.pitch}>
        <g fill="none" stroke="rgba(255,255,255,0.05)" strokeWidth="1.5">
          <circle cx="600" cy="0" r="210" />
          <circle cx="600" cy="0" r="8" fill="rgba(255,255,255,0.05)" stroke="none" />
          <line x1="0" y1="0.75" x2="1200" y2="0.75" />
        </g>
      </svg>
      <div style={fcBgStyles.vignette} />
    </div>
  );
}
const fcBgStyles = {
  wrap: { position: 'fixed', inset: 0, zIndex: 0, overflow: 'hidden', pointerEvents: 'none' },
  glowRed: { position: 'absolute', top: '-25%', left: '50%', width: '90vw', height: '70vh', transform: 'translateX(-50%)',
    background: 'radial-gradient(ellipse at center, rgba(225,18,23,0.30), transparent 62%)', filter: 'blur(18px)' },
  glowPitch: { position: 'absolute', bottom: '-32%', left: '-12%', width: '65vw', height: '62vh',
    background: 'radial-gradient(ellipse at center, rgba(59,165,93,0.20), transparent 65%)', filter: 'blur(30px)' },
  glowGold: { position: 'absolute', bottom: '-30%', right: '-10%', width: '55vw', height: '55vh',
    background: 'radial-gradient(ellipse at center, rgba(230,183,60,0.13), transparent 65%)', filter: 'blur(28px)' },
  turf: { position: 'absolute', inset: 0,
    background: 'repeating-linear-gradient(90deg, rgba(59,165,93,0.14) 0 110px, transparent 110px 220px)',
    maskImage: 'radial-gradient(ellipse at 50% 60%, #000 20%, transparent 78%)',
    WebkitMaskImage: 'radial-gradient(ellipse at 50% 60%, #000 20%, transparent 78%)' },
  grid: { position: 'absolute', inset: 0,
    backgroundImage: 'linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px)',
    backgroundSize: '52px 52px', maskImage: 'radial-gradient(ellipse at 50% 30%, #000 30%, transparent 80%)',
    WebkitMaskImage: 'radial-gradient(ellipse at 50% 30%, #000 30%, transparent 80%)' },
  pitch: { position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' },
  vignette: { position: 'absolute', inset: 0, background: 'radial-gradient(ellipse at 50% 40%, transparent 45%, rgba(0,0,0,0.65) 100%)' },
};

/* ============================================================
   PITCH LINES — половина поля для фона панелей
   ============================================================ */
export function PitchLines({ style, opacity = 1 }) {
  return (
    <svg viewBox="0 0 300 400" preserveAspectRatio="xMidYMax slice" aria-hidden="true"
      style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', opacity, pointerEvents: 'none', ...style }}>
      <g fill="none" stroke="rgba(59,165,93,0.5)" strokeWidth="1.4">
        <rect x="20" y="-20" width="260" height="400" rx="2" />
        <line x1="20" y1="190" x2="280" y2="190" />
        <circle cx="150" cy="190" r="44" />
        <circle cx="150" cy="190" r="3" fill="rgba(59,165,93,0.5)" stroke="none" />
        <rect x="75" y="300" width="150" height="80" />
        <rect x="112" y="345" width="76" height="35" />
        <path d="M110 300 A 42 42 0 0 1 190 300" />
      </g>
    </svg>
  );
}

/* сетка ворот — паттерн-оверлей */
export function NetPattern({ opacity = 0.05 }) {
  return (
    <div aria-hidden="true" style={{ position: 'absolute', inset: 0, pointerEvents: 'none', opacity,
      backgroundImage: 'linear-gradient(rgba(255,255,255,0.9) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.9) 1px, transparent 1px)',
      backgroundSize: '14px 14px', transform: 'skewX(-8deg) scale(1.15)' }} />
  );
}

/* ============================================================
   REVEAL ON SCROLL — <Rv delay={ms}>
   ============================================================ */
export function Rv({ children, delay = 0, style, className }) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) { el.classList.add('in'); io.disconnect(); }
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    io.observe(el);
    return () => io.disconnect();
  }, []);
  return (
    <div ref={ref} className={`rv ${className || ''}`} style={{ ...style, transitionDelay: `${delay}ms` }}>
      {children}
    </div>
  );
}

/* ============================================================
   SCORE TICKER — бегущая строка результатов
   ============================================================ */
export function FCTicker({ items, tag = 'РЕЗУЛЬТАТЫ' }) {
  // items: строки или { b: 'выделенная часть', t: 'текст' }
  const half = (
    <div className="fc-ticker-half">
      {items.map((s, i) => {
        const it = typeof s === 'string' ? { t: s } : s;
        return (
          <span className="fc-ticker-item" key={i}>
            <BallIcon size={13} color="var(--gold)" className="fc-ticker-ball" />
            {it.b && <b className="mono" style={{ color: 'var(--accent-bright)' }}>{it.b}</b>}
            <span>{it.t}</span>
          </span>
        );
      })}
    </div>
  );
  return (
    <div className="fc-ticker" aria-label={tag}>
      <div className="fc-ticker-tag mono">{tag}</div>
      <div className="fc-ticker-viewport">
        <div className="fc-ticker-track">{half}{half}</div>
      </div>
    </div>
  );
}

/* ============================================================
   FUT CARD — карточка игрока с 3D-наклоном и бликом
   ============================================================ */
export function FutCard({ p, delay = 0 }) {
  const ref = useRef(null);
  const canHover = typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(hover:hover)').matches;
  const onMove = (e) => {
    if (!canHover || !ref.current) return;
    const r = ref.current.getBoundingClientRect();
    const x = (e.clientX - r.left) / r.width - 0.5;
    const y = (e.clientY - r.top) / r.height - 0.5;
    ref.current.style.transform = `perspective(700px) rotateY(${x * 14}deg) rotateX(${-y * 12}deg) translateY(-4px)`;
  };
  const onLeave = () => { if (ref.current) ref.current.style.transform = ''; };
  const forms = { 'В': 'var(--ok)', 'Н': 'var(--warn)', 'П': 'var(--danger)' };
  return (
    <div className="fut-slot rv-child" style={{ transitionDelay: `${delay}ms` }}>
      <div className="fut-card" ref={ref} onMouseMove={onMove} onMouseLeave={onLeave} title={`${p.n} · ${p.c} · группа ${p.g}`}>
        <div className="fut-shine" />
        <NetPattern opacity={0.045} />
        <div className="fut-top">
          <div className="col" style={{ alignItems: 'center', gap: 2 }}>
            <span className="fut-ovr display">{p.ovr}</span>
            <span className="fut-pos mono">OVR</span>
          </div>
          <div className="fut-crest">
            <BallIcon size={22} color="var(--gold)" />
          </div>
        </div>
        <div className="fut-nick display">{p.n}</div>
        <div className="fut-club mono">{p.c}</div>
        <div className="fut-divider" />
        <div className="fut-stats">
          {[['АТК', p.atk], ['КНТ', p.ctr], ['ЗАЩ', p.def]].map(([k, v]) => (
            <div className="col" style={{ alignItems: 'center', gap: 2 }} key={k}>
              <span className="fut-stat-v display">{v}</span>
              <span className="fut-stat-k mono">{k}</span>
            </div>
          ))}
        </div>
        <div className="fut-foot">
          <span className="mono fut-group">ГРУППА {p.g}</span>
          <span className="row gap-1">
            {p.form.split('').map((f, i) => (
              <span key={i} title={f === 'В' ? 'победа' : f === 'Н' ? 'ничья' : 'поражение'}
                style={{ width: 7, height: 7, borderRadius: '50%', background: forms[f], boxShadow: `0 0 6px ${forms[f]}` }} />
            ))}
          </span>
        </div>
      </div>
    </div>
  );
}

/* ============================================================
   SEGMENTED CONTROL — [Группы | Плей-офф]
   ============================================================ */
export function Seg({ value, options, onChange }) {
  const idx = Math.max(0, options.findIndex(o => o.value === value));
  return (
    <div className="fc-seg" role="tablist">
      <span className="fc-seg-thumb" style={{ width: `calc(${100 / options.length}% - 4px)`, transform: `translateX(${idx * 100}%)` }} />
      {options.map(o => (
        <button key={o.value} role="tab" aria-selected={value === o.value}
          className={`fc-seg-btn display ${value === o.value ? 'on' : ''}`}
          onClick={() => onChange(o.value)}>
          {o.icon}{o.label}
        </button>
      ))}
    </div>
  );
}

export function LiveDot({ size = 7 }) {
  return <span className="fc-live-dot" style={{ width: size, height: size }} />;
}
